import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: end;
  flex-wrap: wrap;
`
